<template>
  <div class="solution-section" id="the-solution">
    <h2>{{ title }}</h2>
    <h3>{{subtitle}}</h3>
    <div  v-for="(paragraph, index) in description" :key="index">
      <p class="description">{{ paragraph }}</p>
    </div>
    <h4 class="benefitTitle" v-if="showBenefitTitle">{{ benefitTitle }}</h4>
    <ul class="benefits">
      <li v-for="(benefit, index) in benefits" :key="index">
        <span class="benefit-title">{{ getBenefitTitle(benefit) }}</span>
        {{ getBenefitDescription(benefit) }}
      </li>
    </ul>
    <p class="conclusion">{{ conclusion }}</p>
  </div>
</template>

<script>
export default {
  name: 'SolutionSection',
  props: {
    title: String,
    subtitle: String,
    description: Array,
    benefitTitle: String,
    benefits: Array,
    conclusion: String,
    showBenefitTitle: {
      type: Boolean, 
      default: false, 
    }
  },
  methods: {
    getBenefitTitle(benefit) {
      // Get the part before the colon and add the colon back
      const parts = benefit.split(':');
      return parts[0] + ':';
    },
    getBenefitDescription(benefit) {
      // Get the part after the colon
      const parts = benefit.split(':');
      return parts.length > 1 ? parts[1].trim() : '';
    },
  },
};
</script>

<style scoped>
.solution-section {
  padding: 40px 0;
  text-align: left;
}

h2 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #00AEFF;
}
h3{
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 20px;
}

.description {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}
.benefitTitle{
  margin-bottom: 10px;
}
.benefits {
  list-style: none;
  padding: 0;
}

.benefits li {
  font-size: 16px;
  margin-bottom: 15px;
  position: relative;
  padding-left: 20px;
  line-height: 1.5;
}

.benefits li::before {
  content: '•';
  position: absolute;
  left: 0;
  font-size: 20px;
}

.benefit-title {
  font-weight: bold; /* Bold the part before the colon */
}

@media (max-width: 768px) {
  h2 {
    font-size: 32px;
  }
  h3{
    font-size: 20px;
  }
  
}
</style>